import { CheckIcon } from "@radix-ui/react-icons";
import { CommandItem } from "../ui/command";
import { cn } from "@/lib/utils";
import { Badge } from "../ui/badge";
import { ListingDTO } from "@shaarp/common";
import { useAdminMode } from "@/contexts/admin-mode-provider";

export default function CompanyListingsSelectorItem({
  isSelected,
  listing,
  selectListing,
}: {
  isSelected: boolean;
  listing: ListingDTO;
  selectListing: (listing: ListingDTO) => void;
}) {
  const { isAdminMode } = useAdminMode();

  return (
    <CommandItem
      key={listing.id}
      value={listing.title}
      disabled={listing.ownerType === "shaarp" && !isAdminMode}
      onSelect={() => {
        selectListing(listing);
      }}
      className="justify-between"
    >
      <span>
        <CheckIcon
          className={cn(
            "inline-block h-4 w-4 mr-2 text-primary opacity-0",
            isSelected && "opacity-100"
          )}
        />
        {listing.title}
      </span>
      {listing.companiesCount === 0 ? (
        <Badge variant="outline" className="ml-auto">
          Vide
        </Badge>
      ) : (
        <Badge variant="default" className="ml-auto">
          {listing.companiesCount}
        </Badge>
      )}
    </CommandItem>
  );
}
